<template>
  <!-- 评价中心页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar title="评价中心" left-arrow @click-left="$router.go(-1)" />
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="center">
        <van-tabs @change="handleClick" v-model="activeName">
          <van-tab name="toBeEvaluated" title="待评价">
            <ul v-if="this.productList.length !== 0">
              <li>
                <div
                  class="list"
                  v-for="item in productList"
                  :key="item.record_detail_id"
                >
                  <div class="orderHeader">
                    <span class="orderTitle"
                      >订单编号:{{ item.record_code }}</span
                    >
                  </div>
                  <div class="productInfo" @click.stop="toShopping(item.goods_id)">
                    <div class="productInfoTop">
                      <img :src="item.color_img" alt="" />
                    </div>
                    <p>{{ item.goods_detail_name }}</p>
                  </div>
                  <div class="czBtn">
                    <van-button
                      class="pingjia"
                      @click="
                        $router.push({
                          path: '/serviceEvaluation',
                          query: {
                            orderCode: item.record_code,
                            img: item.color_img,
                            id: item.goods_id,
                            record_detail_id: item.record_detail_id,
                          },
                        })
                      "
                      round
                      color="#ffffff"
                      size="small"
                      plain
                      >评价</van-button
                    >
                  </div>
                </div>
              </li>
            </ul>
            <div v-else class="imgBox" style="background-color: #F5F5F5;">
              <img src="../../assets/img/组 9707@2x.png" alt="" />
            </div>
          </van-tab>
          <van-tab name="evaluated" title="已评价"
            ><ul v-if="this.productEvaluateList.length !== 0">
              <li>
                <div
                  class="list"
                  v-for="item in productEvaluateList"
                  :key="item.record_detail_id"
                >
                  <div class="orderHeader">
                    <span class="orderTitle"
                      >订单编号:{{ item.record_code }}</span
                    >
                  </div>
                  <div class="productInfo" @click.stop="toShopping(item.goods_id)">
                    <div class="productInfoTop">
                      <img :src="item.color_img" alt="" />
                    </div>
                    <p>{{ item.goods_detail_name }}</p>
                  </div>
                  <div
                    style="border-bottom: 0.026667rem solid #eeeeee;margin:0 0.266667rem 0 0.32rem;"
                  ></div>
                  <div class="Btn" @click="getDetail(item)">
                    <span style="font-size: 0.346667rem;margin-left: 0.35rem;">
                      商品评分：</span
                    ><van-rate
                      readonly
                      size="0.346667rem"
                      v-model="item.score"
                    />
                    <div v-if="item.remark !== ''">
                      <span
                        style="margin-left: 0.35rem;"
                        class="evaluationContent"
                        >{{ item.remark }}</span
                      >
                      <!-- 图片审核 -->
                      <img
                        v-for="(element, index) in item.commentFileList"
                        :key="element.id"
                        :src="element.imgUrl"
                        @click.stop="showImagePreview(item, index)"
                        alt=""
                      />
                    </div>
                    <div v-else>
                      <span>你没有填写评价内容</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div v-else class="imgBox">
              <img src="../../assets/img/组 9707@2x.png" alt="" />
            </div>
          </van-tab>
        </van-tabs>
        <van-image-preview v-model="ImagePreviewShow" :images="imagesLists">
        </van-image-preview>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      isLoading: false,
      productList: [],
      productEvaluateList: [],
      activeName: "toBeEvaluated",
      commentList: [],
      imgList: [],
      imagesLists: [],
      ImagePreviewShow: false,
      carouselImg: [],
      pageIndex: "",
    };
  },
  created() {
    this.getMyOrder();
    this.getEvaluate();
  },
  mounted() {
    this.updateType();
  },
  methods: {
    // 下拉刷新
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    updateType() {
      let type = location.search;
      //通过拿到的值不同，更改activeName的值
      if (type === "?type=1") {
        this.activeName = "toBeEvaluated";
      } else if (type === "?type=2") {
        this.activeName = "evaluated";
      }
    },
    handleClick(tab) {
      let queryType;
      if (tab == "toBeEvaluated") {
        queryType = 1;
      } else if (tab == "evaluated") {
        queryType = 2;
      }
      this.$router.replace({
        path: "/evaluationCenter",
        query: {
          type: queryType || 1,
        },
      });
    },
    // 获取待评价的订单
    async getMyOrder() {
      await this.$post({
        url: "oor/getRecordDetailByCommentStatus",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          status: 0,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.productList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取已评价的订单
    async getEvaluate() {
      await this.$post({
        url: "oor/getRecordDetailByCommentStatus",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          status: 1,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.productEvaluateList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转到评论详细
    getDetail(item) {
      sessionStorage.setItem("record_detail_id", item.record_detail_id);
      this.$router.push({
        path: "/particular",
        query: {
          recordDetailId: item.record_detail_id,
        },
      });
    },
    showImagePreview(item, index) {
      this.carouselImg = [];
      item.commentFileList.forEach((element) => {
        this.carouselImg.push(element.imgUrl);
      });
      // 图片下标
      this.pageIndex = index;
      ImagePreview({
        images: this.carouselImg,
        // 关闭按钮
        closeable: true,
        // 开启循环播放
        loop: false,
        // 显示页码
        showIndex: true,
        // 图片预览起始索引
        startPosition: this.pageIndex,
      });
    },
    toShopping(id) {
      sessionStorage.setItem("P_ID", id);
      this.$router.push("/toShopping");
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  min-height: 100%;
  width: 100%;
  position: relative;
  background: #e8e8e8;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #fff;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .center {
    margin: 0rem 0.27rem 0 0.27rem;
    background-color: #1f000000;
    padding-top: 1.2rem;
    ul {
      height: 100%;
      width: 100%;
      .list {
        margin-top: 0.266667rem;
        background-color: #ffffff;
        .orderHeader {
          background-color: #ffffff;
          .orderTitle {
            color: #333333;
            font-size: 0.373333rem;
            font-family: PingFang SC;
            border-bottom: 0.013333rem solid #eeeeee;
            margin: 0 0.266667rem 0 0.32rem;
            background-color: #ffffff;
            display: block;
            line-height: 1.093333rem;
            height: 1.093333rem;
          }
        }
        .productInfo {
          display: flex;
          align-items: center;
          .productInfoTop {
            padding: 0.266667rem 0 0.266667rem 0.453333rem;
            img {
              width: 2.053333rem;
              // height: 1.466667rem;
              height: auto;
            }
          }
          p {
            margin-left: 0.426667rem;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }
        }
        .czBtn {
          overflow: hidden;
          padding-bottom: 0.533333rem;
          .pingjia {
            float: right;
            padding: 0 0.4rem;
            background-color: #f74b2e;
            margin: 0 0.426667rem 0 0;
          }
        }
        .Btn {
          margin: 0.373333rem 0.27rem;
          .evaluationContent {
            margin-top: 0.133333rem;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            display: block;
            padding-bottom: 0.373333rem;
          }
          img {
            margin-left: 0.35rem;
            margin-top: 0.1rem;
            width: 2.5rem;
            height: 2.5rem;
          }
          .van-button {
            margin-right: 0.1rem;
          }
        }
      }
    }
  }
  .imgBox {
    background-color: #e8e8e8 !important;
    img {
      width: 6.5rem;
      height: 5.5rem;
      margin: 3rem auto;
      display: block;
    }
  }
}
</style>
